import { createStandardAction } from 'typesafe-actions';

import { CommonError } from 'CommonError-Types';

export const setCommonError = createStandardAction('SET_COMMON_ERROR')<CommonError>();
export const clearCommonError = createStandardAction('CLEAR_COMMON_ERROR')();
export const setIsUIImplementationError = createStandardAction('SET_UI_IMPLEMENTATION_ERROR')<
  boolean
>();
